import { render } from "./HomeView.vue?vue&type=template&id=062b7c0f"
const script = {}

import "./HomeView.vue?vue&type=style&index=0&id=062b7c0f&lang=less"

import exportComponent from "C:\\Users\\admin\\Desktop\\tuoanzhishengwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__